import aed from '@dist/svg/currency/aed.svg';
import aud from '@dist/svg/currency/aud.svg';
import cad from '@dist/svg/currency/cad.svg';
import cny from '@dist/svg/currency/cny.svg';
import eur from '@dist/svg/currency/eur.svg';
import gbp from '@dist/svg/currency/gbp.svg';
import iqd from '@dist/svg/currency/iqd.svg';
import irr from '@dist/svg/currency/irr.svg';
import irt from '@dist/svg/currency/irt.svg';
import jpy from '@dist/svg/currency/jpy.svg';
import kwd from '@dist/svg/currency/kwd.svg';
import try_ from '@dist/svg/currency/try.svg';
import _undefined from '@dist/svg/currency/undefined.svg';
import usa from '@dist/svg/currency/usa.svg';
import usd from '@dist/svg/currency/usd.svg';

export const currencyDetailsPrototype = {
	AED: {
		symbol: 'AED',
		img: aed,
		enName: '',
		faName: 'درهم',
	},
	AUD: {
		symbol: 'AUD',
		img: aud,
		enName: '',
		faName: 'دلار استرالیا',
	},
	CAD: {
		symbol: 'CAD',
		img: cad,
		enName: '',
		faName: 'دلار کانادا',
	},
	CNY: {
		symbol: 'CNY',
		img: cny,
		enName: '',
		faName: 'یوان چین',
	},
	EUR: {
		symbol: 'EUR',
		img: eur,
		enName: '',
		faName: 'یورو',
	},
	GBP: {
		symbol: 'GBP',
		img: gbp,
		enName: '',
		faName: 'پوند انگلیس',
	},
	IQD: {
		symbol: 'IQD',
		img: iqd,
		enName: '',
		faName: 'دینار عراق',
	},
	IRR: {
		symbol: 'IRR',
		img: irr,
		enName: 'Rial',
		faName: 'ریال',
	},
	IRT: {
		symbol: 'IRT',
		img: irt,
		enName: 'Toman',
		faName: 'تومان',
	},
	JPY: {
		symbol: 'JPY',
		img: jpy,
		enName: '',
		faName: 'ین ژاپن',
	},
	KWD: {
		symbol: 'KWD',
		img: kwd,
		enName: '',
		faName: 'دینار کویت',
	},
	TRY: {
		symbol: 'TRY',
		img: try_,
		enName: '',
		faName: 'لیر ترکیه',
	},
	USA: {
		symbol: 'USA',
		img: usa,
		enName: 'Dollar',
		faName: 'دلار',
	},
	USD: {
		symbol: 'USD',
		img: usd,
		enName: 'Dollar',
		faName: 'دلار آمریکا',
	},
	undefined: {
		symbol: '',
		img: _undefined,
		enName: '',
		faName: '',
	},
};
